module.exports = __webpack_public_path__ + "img/bed_n.9b65e94b.png";